import { Provider } from '@angular/core';
import {
  GetVesselHotoFormUseCase,
  GetVesselHotoSetsUseCase,
  SaveVesselHotoFormDraftUseCase,
  StartNewVesselHotoSetUseCase,
  SubmitVesselHotoFormUseCase,
} from '@app/application/use-cases/vessel-hoto-form';
import { VesselHotoFormRepository } from '@app/domain/repositories/vessel-hoto-form.repository';
import { VesselHotoFormRepositoryImpl } from '../repositories/vessel-hoto-form.repository.impl';

export const VESSEL_HOTO_FORM_PROVIDERS: Provider[] = [
  {
    provide: VesselHotoFormRepository,
    useClass: VesselHotoFormRepositoryImpl,
  },
  {
    provide: GetVesselHotoFormUseCase,
    useFactory: (repo: VesselHotoFormRepository) =>
      new GetVesselHotoFormUseCase(repo),
    deps: [VesselHotoFormRepository],
  },
  {
    provide: SubmitVesselHotoFormUseCase,
    useFactory: (repo: VesselHotoFormRepository) =>
      new SubmitVesselHotoFormUseCase(repo),
    deps: [VesselHotoFormRepository],
  },
  {
    provide: SaveVesselHotoFormDraftUseCase,
    useFactory: (repo: VesselHotoFormRepository) =>
      new SaveVesselHotoFormDraftUseCase(repo),
    deps: [VesselHotoFormRepository],
  },
  {
    provide: GetVesselHotoSetsUseCase,
    useFactory: (repo: VesselHotoFormRepository) =>
      new GetVesselHotoSetsUseCase(repo),
    deps: [VesselHotoFormRepository],
  },
  {
    provide: StartNewVesselHotoSetUseCase,
    useFactory: (repo: VesselHotoFormRepository) =>
      new StartNewVesselHotoSetUseCase(repo),
    deps: [VesselHotoFormRepository],
  },
];
